import styled from 'styled-components'

import { FieldSkeleton } from '@/components/layout/field-row'

export const TypeIcon = styled.span<{ $color: string }>(({ theme, $color }) => ({
  alignItems: 'center',
  backgroundColor: $color,
  borderRadius: theme.border.radius['8'],
  color: theme.colors.white,
  display: 'flex',
  flexShrink: 0,
  // Note: smaller than the row's text block (title 2rem + subtitle 1.6rem + gap), so it never sets the row height
  height: '3.6rem',
  justifyContent: 'center',

  svg: {
    maxHeight: '2.2rem',
    maxWidth: '2.2rem',
  },
  width: '3.6rem',
}))

// Note: stands in for the buildings count text in the subtitle
export const BuildingsTextSkeleton = styled(FieldSkeleton)(() => ({
  flexShrink: 0,
}))
